import { ReactNode } from 'react';

import styles from '../IncodeSdkPage.scss';

export const IncodeHeader = ({ instructions, title }: { instructions?: ReactNode; title: ReactNode }) => (
  <>
    <h1 className={styles.title}>{title}</h1>
    {instructions && <p className={styles.instructions}>{instructions}</p>}
  </>
);
